import { render, staticRenderFns } from "./DocumentValue.vue?vue&type=template&id=3955e8b4"
import script from "./DocumentValue.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentValue.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports